import React from 'react'
import { I18n } from 'react-redux-i18n'

export default ({ onClick }) => (
  <button
    onClick={onClick}
    className="w-full bg-white border border-gray-200 rounded-lg p-3 hover:border-primary-500 hover:shadow-md transition-all duration-200 text-center group"
  >
    <svg
      className="w-5 h-5 text-gray-400 group-hover:text-primary-600 mx-auto mb-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
      />
    </svg>
    <span className="text-gray-900 font-medium text-sm">
      {I18n.t('checkInScene.field.creditCard')}
    </span>
  </button>
)
